import React, { useState, useEffect } from 'react';
import homeIcon from './../../Constant/Icons/dashboard.svg';
// import info from './../../Constant/Icons/info.svg';
import services from '../../Constant/Icons/services.svg';
// import payment from '../../Constant/Icons/payment.svg';
// import appIcon from '../../Constant/Icons/application.svg';
import { useLocation, useNavigate } from 'react-router-dom';

function VerifierSideBar({ onRouteChange,admin }) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
    const location = useLocation(); // Hook to get the current URL
    const navigate = useNavigate();

    // Toggle the sidebar open/closed state
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Function to handle route changes, both from sidebar and other sources
    const handleRouteChange = (route) => {
        if (location.pathname !== route) {
            navigate(route); // Navigate programmatically
            onRouteChange(route); // Callback if needed
        }
    };

    useEffect(() => {
        setIsSidebarOpen(window.innerWidth >= 1024);
    }, [window.innerWidth])

    return (
        <div className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
            <button className="toggle-btn" onClick={toggleSidebar}>
                {isSidebarOpen ? '☰' : '☰'}
            </button>
            <ul>
                <li
                    onClick={() => handleRouteChange('/cv/verifier/dashboard')}
                    className={location.pathname === '/cv/verifier/dashboard' ? 'active' : ''}
                >
                    <img src={homeIcon} alt="Dashboard" width={20} height={20} />
                    {isSidebarOpen ? <span>Dashboard</span> : null}
                </li>
                <li
                    onClick={() => handleRouteChange('/cv/verifier/dashboard/verification-window')}
                    className={location.pathname === '/cv/verifier/dashboard/verification-window' ? 'active' : ''}
                >
                    <img src={services} alt="Services" width={20} height={20} />
                    {isSidebarOpen ? <span>Verification Window</span> : null}
                </li>
            </ul>
        </div>
    )
}

export default VerifierSideBar;